import { render, staticRenderFns } from "./LigneViergeSyndic.vue?vue&type=template&id=17610696&"
import script from "./LigneViergeSyndic.vue?vue&type=script&lang=js&"
export * from "./LigneViergeSyndic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports